import { useSelector } from 'react-redux';

import { userHasPermission as p } from '@legacy-libs/utils';
import { selectUser } from '@legacy-redux/auth/selectors';

import { Menu, MenuItem, MenuSection } from '@shared/layout/components/Menu';

export function AdminMenu() {
  const user = useSelector(selectUser);

  return (
    <Menu>
      {p(user, ['reports.excel']) && (
        <MenuSection key="statistics-dashboard" title="Live Dashboard" icon="line-graph" to="/admin/dashboard" />
      )}

      {p(user, ['venues.venues', 'venues.zones'], '||') && (
        <MenuSection key="venues" title="Venues" icon="map">
          {p(user, ['venues.venues']) && (
            <>
              <MenuItem title="Venues" to="/admin/venues" />
              {process.env.REACT_APP_ENV === 'dev' && <MenuItem title="Venues v2" to="/admin/new-venues" />}
            </>
          )}
          {p(user, ['venues.zones']) && <MenuItem title="Zones" to="/admin/zones" />}
        </MenuSection>
      )}

      {p(user, ['events.events', 'events.periods'], '||') && (
        <MenuSection key="events" title="Events" icon="calendar">
          {p(user, ['events.events']) && <MenuItem title="Events" to="/admin/events" />}
          {p(user, ['events.periods']) && <MenuItem title="Periods" to="/admin/periods" />}
        </MenuSection>
      )}

      {p(user, ['companies.companies', 'companies.companyUsers'], '||') && (
        <MenuSection key="companies" title="Companies" icon="building">
          {p(user, ['companies.companies']) && <MenuItem title="Companies" to="/admin/companies" />}
          {p(user, ['companies.companyUsers']) && <MenuItem title="Employees" to="/admin/employees" />}
        </MenuSection>
      )}

      {p(user, ['registrations.registrations']) && [
        <MenuSection key="registrations" title="Registrations" icon="registrations" to="/admin/registrations" />,
      ]}

      {p(user, ['wristbands.wristbands', 'wristbands.profileMaterialScan', 'wristbands.accessVoucherScan'], '||') && (
        <MenuSection key="wristbands" title="Wristbands" icon="barcode">
          {p(user, ['wristbands.wristbands']) && <MenuItem title="All Wristbands" to="/admin/wristbands" />}
          {p(user, ['wristbands.accessVoucherScan']) && <MenuItem title="Printers" to="/admin/printers" />}
          {p(user, ['wristbands.accessVoucherScan']) && <MenuItem title="Front Desk" to="/admin/front-desk" />}
          {p(user, ['wristbands.profileMaterialScan']) && (
            <MenuItem title="Crew Materials" to="/admin/crew-materials" />
          )}
        </MenuSection>
      )}

      {p(user, ['timeTracking.scan', 'timeTracking.admin'], '||') && (
        <MenuSection key="time-tracking" title="Time Tracking" icon="clock" to="/admin/time-tracking-groups" />
      )}

      {p(user, ['wristbands.parkingVoucherScan']) && (
        <MenuSection key="parking_stickers" title="Parking Stickers" icon="sticky-note">
          {p(user, ['wristbands.parkingVoucherScan']) && (
            <MenuItem title="Sticker Handout" to="/admin/parking-vouchers" />
          )}

          {p(user, ['wristbands.parkingVoucherScan']) && <MenuItem title="Stickers" to="/admin/parking-stickers" />}
        </MenuSection>
      )}

      {p(
        user,
        ['gatekeeping.gates', 'gatekeeping.locations', 'gatekeeping.transportRequests', 'gatekeeping.frequentPassages'],
        '||'
      ) && (
        <MenuSection key="gatekeeping" title="Gatekeeping" icon="truck">
          {p(user, ['gatekeeping.transportRequests']) && (
            <>
              <MenuItem title="Transport Requests" to="/admin/transport-requests" />
              <MenuItem title="Transport Log" to="/admin/transport-scans" />
            </>
          )}
          {p(user, ['gatekeeping.frequentPassages']) && (
            <>
              <MenuItem title="Frequent Passage Requests" to="/admin/frequent-passage-requests" />
              <MenuItem title="Frequent Passage Handout" to="/admin/frequent-passage-stickers/voucher-search" />
            </>
          )}
          {p(user, ['gatekeeping.gates']) && <MenuItem title="Gates" to="/admin/gates" />}
          {p(user, ['gatekeeping.locations']) && <MenuItem title="Locations" to="/admin/locations" />}
        </MenuSection>
      )}

      {p(user, ['materials.material-requests', 'materials.materialRequests', 'materials.materialRentals'], '||') && (
        <MenuSection key="materials" title="Materials" icon="walkie">
          {p(user, ['materials.materialRequests']) && <MenuItem title="Requests" to="/admin/material-requests" />}
          {p(user, ['materials.materialRentals']) && <MenuItem title="Rental" to="/admin/rental" />}
          {p(user, ['materials.materials']) && <MenuItem title="Materials" to="/admin/materials" />}
          {p(user, ['materials.materials']) && <MenuItem title="Material Categories" to="/admin/material-categories" />}
        </MenuSection>
      )}

      {p(user, ['certificates.admin']) && (
        <MenuSection key="certificates" title="Certificates" icon="certificate" to="/admin/certificates" />
      )}

      {p(user, ['settings.profiles', 'settings.occupations', 'settings.departments'], '||') && (
        <MenuSection key="settings" title="Settings" icon="gear">
          {p(user, ['settings.departments']) && <MenuItem title="Departments" to="/admin/departments" />}
          {p(user, ['settings.profiles']) && <MenuItem title="Profiles" to="/admin/profiles" />}
          {p(user, ['settings.profiles']) && <MenuItem title="Profile Groups" to="/admin/profile-groups" />}
          {p(user, ['settings.occupations']) && <MenuItem title="Functions" to="/admin/functions" />}
          {p(user, ['settings.emailTemplates']) && <MenuItem title="Emails" to="/admin/emails" />}
        </MenuSection>
      )}

      {p(user, ['reports.excel'], '||') && (
        <MenuSection key="logs" title="Logs" icon="diagram">
          {p(user, ['reports.excel']) && <MenuItem title="Catering Claims" to="/admin/catering-claims" />}
          {p(user, ['logs.activity']) && <MenuItem title="Activity Logs" to="/admin/activity" />}
        </MenuSection>
      )}

      {p(user, ['reports.excel', 'reports.invoices'], '||') && (
        <MenuSection key="reports" title="Reports" icon="line-graph">
          {p(user, ['reports.excel']) && <MenuItem title="Exports" to="/admin/exports" />}
          {p(user, ['reports.invoices']) && <MenuItem title="Invoices" to="/admin/invoices" />}
        </MenuSection>
      )}

      {p(user, ['system.scheduledJobs', 'system.devices'], '||') && (
        <MenuSection key="system" title="System" icon="desktop">
          {p(user, ['system.scheduledJobs']) && <MenuItem title="Queue" to="/admin/queue" />}
          {p(user, ['system.scheduledJobs']) && <MenuItem title="Tokens" to="/admin/tokens" />}
          {p(user, ['system.devices']) && <MenuItem title="Devices" to="/admin/devices" />}
        </MenuSection>
      )}

      {p(user, ['users.users', 'users.groups'], '||') && (
        <MenuSection key="user" title="User Management" icon="users">
          {p(user, ['users.users']) && <MenuItem title="Users" to="/admin/users" />}
          {p(user, ['users.groups']) && <MenuItem title="Groups" to="/admin/groups" />}
        </MenuSection>
      )}
    </Menu>
  );
}
